import { createAsyncThunk } from '@reduxjs/toolkit'
import { Payload } from 'stores'
import {
  createGenericSlice,
  createReducers,
  ExtraReducers,
  GenericState,
} from 'stores/generics'
import {
  STORE_BILL,
  STORE_BILL_REFUND_BALANCE,
  STORE_STATUS_INITIALIZED,
} from 'constants/store'
import { ErrorStore, RefundBalance } from '@types'

type State = GenericState<RefundBalance>

export const initialState: State = {
  data: {
    credit_amount: 0,
    cashins: [],
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchRefundBalance = createAsyncThunk<
  RefundBalance,
  Promise<RefundBalance>,
  Payload
>(STORE_BILL_REFUND_BALANCE, async (promise, { rejectWithValue }) => {
  try {
    return await promise
  } catch (e: unknown) {
    const { code, message } = e as ErrorStore
    return rejectWithValue({ code, message })
  }
})

const extraReducers: ExtraReducers = createReducers<
  RefundBalance,
  RefundBalance,
  Payload
>(fetchRefundBalance, initialState.data)

const slice = createGenericSlice({
  name: STORE_BILL,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = slice

const { clear, success } = actions

export { clear, success }

export default reducer
